import { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { IonModal, IonItem, IonLabel, IonInput, IonButton } from "@ionic/react";
import "./ModalActualizarContrasena.css";
import { actualizarContrasena } from "../../../apiClient/rutes/usuarios";

const ModalActualizarContrasenia = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showModal, setShowModal] = useState(!!token); // Mostrar el modal solo si hay un token
  const history = useHistory();

  const handlePasswordUpdate = async () => {
    if (newPassword !== confirmPassword) {
      alert("Las contraseñas no coinciden");
      return;
    }

    try {
      const response = await actualizarContrasena(token, newPassword);

      if (response.status === 200) {
        alert("Contraseña actualizada correctamente.");
        setShowModal(false);
        history.push("/Login"); // Redirige al login después de cambiar la contraseña
      }
    } catch (error) {
      console.error("Error actualizando la contraseña:", error);
      alert("Error en la actualización de la contraseña. Intente nuevamente.");
    }
  };

  // No renderizar el modal si no hay token en la URL
  if (!token) {
    return null;
  }

  return (
    <IonModal isOpen={showModal} cssClass="custom-modal">
      <div style={{ padding: "20px" }}>
        <h2>Actualizar Contraseña</h2>
        <IonItem>
          <IonLabel position="stacked">Nueva Contraseña</IonLabel>
          <IonInput type="text" value={newPassword} onIonChange={(e) => setNewPassword(e.detail.value)} />
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">Confirmar Contraseña</IonLabel>
          <IonInput type="text" value={confirmPassword} onIonChange={(e) => setConfirmPassword(e.detail.value)} />
        </IonItem>
        <br />
        <IonButton onClick={handlePasswordUpdate} color="success">
          Actualizar
        </IonButton>
        <IonButton onClick={() => setShowModal(false)} color="danger">
          Cancelar
        </IonButton>
      </div>
    </IonModal>
  );
};

export default ModalActualizarContrasenia;
